import React from "react"
import PropTypes from "prop-types"

import dateTimeWithTimeFormat from '../utils/dateTimeWithTimeFormat'
import ChatTextArea from './ChatTextArea';
import LoaderSection from '../app_components/LoaderSection';
import Icon from '../app_components/Icon';

class ChatContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      msgs: [],
      textbox: '',
      loaded: false
    }

    this.loadMsgs = this.loadMsgs.bind(this)
    this.renderMsgs = this.renderMsgs.bind(this)
    this.sendMessage = this.sendMessage.bind(this)
    this.updateText = this.updateText.bind(this)
    this.scrollToBottom = this.scrollToBottom.bind(this)
    this.otherUser = this.otherUser.bind(this)
  }

  componentDidMount() {
    this.loadMsgs()
    this.markAsRead()
  }

  markAsRead() {
    $.ajax({
      url: `../markAsRead`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        convo_id: this.props.convoId,
      },
      success: (data) => {
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  loadMsgs() {
    $.ajax({
      url: `../getConvoMsgs`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        convo_id: this.props.convoId,
      },
      success: (data) => {
        this.setState({
          convo: JSON.parse(data.data.convo),
          msgs: JSON.parse(data.data.msgs),
          currentUser: JSON.parse(data.data.current_user),
          loaded: true
        }, () => this.scrollToBottom())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  sendMessage(msg) {
    $.ajax({
      url: `../sendMessage`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        convo_id: this.props.convoId,
        msg: msg
      },
      success: (data) => {
        this.setState({
          msgs: JSON.parse(data.data.msgs),
          textbox: ''
        }, () => this.scrollToBottom())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });

  }

  scrollToBottom = () => {
    if (this.messagesEnd) {
      this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
  }

  otherUser() {
    if (!this.state.convo || !this.state.currentUser) {
      return null;
    }

    const { sender, recipient } = this.state.convo;
    return sender.id === this.state.currentUser.id ? recipient : sender;
  }

  avatarUrl(user) {
    if (!user) {
      return this.props.missingImg;
    }

    return user.avatar_url === "medium/missing.png" ? this.props.missingImg : user.avatar_url;
  }

  renderMsgs() {
    return this.state.msgs.map((msg, i) => {
      const isSelf = msg.user.id === this.state.currentUser.id;

      return(
        <div
          key={i}
          className={`chat-panel__message ${isSelf ? 'chat-panel__message--self' : 'chat-panel__message--other'}`}
        >
          {!isSelf && (
            <img
              onClick={() => window.location.assign(`/profile/${msg.user.slug}`)}
              src={this.avatarUrl(msg.user)}
              className="chat-panel__avatar"
              alt=""
            />
          )}
          <div className="chat-panel__bubble">
            <p className="chat-panel__body">{msg.body}</p>
            <p className="chat-panel__meta">
              {isSelf
                ? dateTimeWithTimeFormat(msg.created_at)
                : `${msg.user.preferred_name}, ${dateTimeWithTimeFormat(msg.created_at)}`}
            </p>
          </div>
          {isSelf && (
            <img
              onClick={() => window.location.assign(`/profile/${msg.user.slug}`)}
              src={this.avatarUrl(msg.user)}
              className="chat-panel__avatar"
              alt=""
            />
          )}
        </div>
      )
    })
  }

  updateText(text) {
    this.setState({
      textbox: text
    })
  }

  renderHeader() {
    const otherUser = this.otherUser();

    return (
      <header className="chat-panel__header">
        <div className="chat-panel__headerMain">
          {otherUser && (
            <img
              onClick={() => window.location.assign(`/profile/${otherUser.slug}`)}
              src={this.avatarUrl(otherUser)}
              className="chat-panel__headerAvatar"
              alt=""
            />
          )}
          <div className="chat-panel__headerText">
            <h2 className="chat-panel__title">
              {otherUser ? otherUser.preferred_name : 'Chat'}
            </h2>
            <p className="chat-panel__subtitle">Connected</p>
          </div>
        </div>
        <button
          type="button"
          className="chat-panel__close"
          onClick={() => this.props.closeChat()}
          aria-label="Close chat"
        >
          <Icon name="times" size={22} color="currentColor" />
        </button>
      </header>
    );
  }

  render() {
    return(
      <div className="chat-panel-overlay">
        <div className="chat-panel" role="dialog" aria-modal="true" aria-label="Chat">
          {this.renderHeader()}
          <div className="chat-panel__messages">
            {!this.state.loaded ? (
              <div className="chat-panel__loader">
                <LoaderSection height={120} width={120} />
              </div>
            ) : (
              <>
                {this.renderMsgs()}
                <div ref={(el) => { this.messagesEnd = el; }} />
              </>
            )}
          </div>
          {this.state.loaded && (
            <ChatTextArea
              textbox={this.state.textbox}
              updateText={this.updateText}
              sendMessage={this.sendMessage}
            />
          )}
        </div>
      </div>
    )
  }

}

export default ChatContainer;
